import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { UserMembership } from "@main-services/user-membership.service";
import { UserVerificationState } from "@models";

@Component({
	selector: "bp-profile-picture",
	templateUrl: "./bp-profile-picture.component.html",
	styleUrls: ["./bp-profile-picture.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpProfilePictureComponent implements OnChanges {
	@Input() public membership: string;
	@Input() public userStatus: string = "";
	@Input() public logo: string = "/assets/images/panda-grey.svg";
	@Input() public cssClass: string = "";

	public userMembership = UserMembership;
	public userVerificationStatus = UserVerificationState;
	public validationLogo: string = "";

	public ngOnChanges(changes: SimpleChanges): void {
		const change = changes.valueOf();
		if (change.hasOwnProperty("membership") || change.hasOwnProperty("userStatus")) {
			this.validationLogo = this.getValidationLogoUrl(this.membership, this.userStatus);
		}
	}

	private getValidationLogoUrl(membership, userStatus): string {
		if (membership === UserMembership.Normal) {
			if (userStatus === UserVerificationState.VERIFIED) {
				return "/assets/images/icon_verify_complete.svg";
			} else if (userStatus === UserVerificationState.DOCUMENTED) {
				return "/assets/images/icon_verify_light.svg";
			}
		} else if (userStatus === UserVerificationState.VERIFIED) {
			if (membership === UserMembership.Gold) {
				return "/assets/images/validation-club-gold.svg";
			} else if (membership === UserMembership.Silver) {
				return "/assets/images/validation-club-silver.svg";
			}
			return "/assets/images/icon_verify_complete.svg";
		}

		return "";
	}
}
